// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__m5a4n","head":"Table_head__28OVQ","col":"Table_col__308n9"};